Object.defineProperty(exports, '__esModule', {
  value: true
});

function namespaceOptions(prefix, options) {
  // adds vst- to all options (since they get added as classes)
  if (!options) { return []; }
  return options.split(' ').map((option) => {
    if (option.indexOf(`${prefix}-`) === 0) {
      return option;
    }
    return `${prefix}-${option}`;
  });
}

exports.default = namespaceOptions;
